<div *ngIf="isLoading" class="loading">
  <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
</div>

<con-page-layout>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2>{{ 'datasets_title' | translate }}</h2>
    <div fxFlex></div>
  </div>
  <div class="sub-title">{{ 'datasets_subTitle' | translate }}</div>
  <div fxLayout="row" fxLayoutAlign="end start">
    <a mat-raised-button color="primary" *ngIf="isAdministrator" (click)="sidenavdataset.open()">
      <mat-icon>add</mat-icon>{{ 'add_dataset' | translate }}
    </a>
  </div>

  <con-page-layout-content fxLayout="column" fxLayoutGap="16px">
    <mat-sidenav-container [hasBackdrop]="false">
      <mat-sidenav class="sidenav-panel" #sidenavdataset mode="over" position="end" [fixedInViewport]="true"
        [fixedTopGap]="isMobile() ? 120 : 64" [disableClose]="true">
        <app-add-dataset [dataset]="dataset" (saved)="sidenavdataset.close(); addedDataset($event)"
          (cancelled)="sidenavdataset.close(); cancelledDataset($event)" (loadingSpinner)="loadingSpinner($event)">
        </app-add-dataset>
      </mat-sidenav>
    </mat-sidenav-container>

    <div  *ngIf="media.isActive('lg') || media.isActive('xl') || media.isActive('md')" class="matTable-container">
      <mat-table matSort #table [dataSource]="dataSource"
        class="mat-elevation-z8">
  
        <!-- Dataset Name Column -->
        <ng-container cdkColumnDef="name">
          <mat-header-cell fxFlex="20%" *cdkHeaderCellDef mat-sort-header>{{ 'dataset_name' | translate }}</mat-header-cell>
          <mat-cell fxFlex="20%" *cdkCellDef="let dataset"> {{dataset.name}} </mat-cell>
        </ng-container>
  
        <!-- Dataset Description Column -->
        <ng-container cdkColumnDef="description">
          <mat-header-cell fxFlex="30%" *cdkHeaderCellDef mat-sort-header>{{ 'dataset_description' | translate }}</mat-header-cell>
          <mat-cell fxFlex="30%" *cdkCellDef="let dataset"> {{dataset.description}} </mat-cell>
        </ng-container>
  
        <!-- Dataset File Column -->
        <ng-container cdkColumnDef="file">
          <mat-header-cell fxFlex="20%" *cdkHeaderCellDef mat-sort-header>{{ 'dataset_file' | translate }}</mat-header-cell>
          <mat-cell fxFlex="20%" *cdkCellDef="let dataset"> {{dataset.file}} </mat-cell>
        </ng-container>
  
        <!-- Backfill Days Column -->
        <ng-container cdkColumnDef="backfillDays">
          <mat-header-cell fxFlex="20%" *cdkHeaderCellDef mat-sort-header>{{ 'dataset_backfillDays' | translate }}</mat-header-cell>
          <mat-cell fxFlex="20%" *cdkCellDef="let dataset"> {{dataset.backfill_days}} </mat-cell>
        </ng-container>
  
        <ng-container cdkColumnDef="menu">
          <mat-header-cell fxFlex="10%" *cdkHeaderCellDef></mat-header-cell>
          <mat-cell fxFlex="10%" *cdkCellDef="let dataset">
  
            <button mat-icon-button [matMenuTriggerData]="{ row: dataset }" [matMenuTriggerFor]="menu" *ngIf="isAdministrator">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="updateDataset(dataset)" matTooltip="Modify Dataset"
                matTooltipPosition="left">
                {{ 'edit' | translate }}
              </button>
              <button mat-menu-item (click)="downloadFile(dataset.file)" matTooltip="Download Dataset"
                matTooltipPosition="left">
                {{ 'download' | translate }}
              </button>
              <button mat-menu-item (click)="deleteDataset(dataset)" matTooltip="Delete Dataset"
                matTooltipPosition="left">
                {{ 'delete' | translate }}
              </button>
            </mat-menu>
  
          </mat-cell>
        </ng-container>
  
        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>
    
    <br />

    <!-- Mobile view -->
    <mat-list *ngIf="!(media.isActive('lg') || media.isActive('xl') || media.isActive('md'))" class="mobile-list">

      <mat-list-item *ngFor="let dataset of dataSource.data">
        <div class="mobile-card">

          <div class="field">
            <span class="label">{{ 'dataset_name' | translate }}</span>
            <span class="value breakword">{{ dataset.name }}</span>
          </div>

          <div class="field">
            <span class="label">{{ 'dataset_description' | translate }}</span>
            <span class="value breakword">{{ dataset.description }}</span>
          </div>

          <div class="field">
            <span class="label">{{ 'dataset_file' | translate }}</span>
            <span class="value breakword">{{ dataset.file }}</span>
          </div>

          <div class="field">
            <span class="label">{{ 'dataset_backfillDays' | translate }}</span>
            <span class="value">{{ dataset.backfill_days }}</span>
          </div>

          <div class="actions" *ngIf="isAdministrator">
            <button mat-stroked-button color="primary" (click)="updateDataset(dataset)">
              {{ 'edit' | translate }}
            </button>
            <button mat-stroked-button color="accent" (click)="downloadFile(dataset.file)">
              {{ 'download' | translate }}
            </button>
            <button mat-stroked-button color="warn" (click)="deleteDataset(dataset)">
              {{ 'delete' | translate }}
            </button>
          </div>
        </div>
      </mat-list-item>

    </mat-list>

  </con-page-layout-content>
</con-page-layout>
